export const SERVER_PORT = 8085;
//export const SERVER_URL = `http://127.0.0.1:${SERVER_PORT}`;
export const SERVER_URL = `https://djautoac.com`;

export const GOOGLE_API_KEY = `AIzaSyBpiFG74dL8a1PUfV19JmObU8-aXgELgK0`;
